// Conversão entre segundos e o formato "m:ss" usado nos campos de duração.

export function formatDuration(seconds: number): string {
    const m = Math.floor(seconds / 60)
    const s = seconds % 60
    return `${m}:${s.toString().padStart(2, '0')}`
}

// Aceita "m:ss", "mm:ss" ou um número puro de segundos. Retorna undefined quando vazio/ inválido.
export function parseDuration(value: string): number | undefined {
    const trimmed = value.trim()
    if (!trimmed) return undefined

    const parts = trimmed.split(':')
    if (parts.length === 1) {
        const n = Number(parts[0])
        return Number.isFinite(n) ? n : undefined
    }

    const mins = Number(parts[0])
    const secs = Number(parts[1])
    if (!Number.isFinite(mins) || !Number.isFinite(secs)) return undefined
    return mins * 60 + secs
}
